var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "centerx" },
    [
      _c(
        "vs-popup",
        {
          staticClass: "content-display-detail vs-con-loading__container",
          attrs: {
            title:
              "Detalle | Campaña: " +
              (_vm.modalData &&
              _vm.modalData.campaignId &&
              _vm.modalData.companyId
                ? `${_vm.modalData.campaignId} - Empresa: ${_vm.modalData.companyId}` +
                  (_vm.modalData.isProgrammatic
                    ? "  | Programática"
                    : "  | Tradicional")
                : "Detalle"),
            active: _vm.isModalActive,
            fullscreen: "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isModalActive = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex flex-col justify-between gap-10 h-full overflow-y-auto px-4",
            },
            [
              _c("section", { staticClass: "flex flex-col gap-10" }, [
                _c(
                  "div",
                  { staticClass: "rounded-lg overflow-hidden" },
                  [
                    _c("h4", [_vm._v("ODCs de cliente/agencia")]),
                    _c("agency-odc-table", {
                      attrs: {
                        data:
                          _vm.data && _vm.data.purchase_orders_agency
                            ? _vm.data.purchase_orders_agency
                            : [],
                      },
                    }),
                  ],
                  1
                ),
                _vm.modalData
                  ? _c(
                      "div",
                      { staticClass: "rounded-lg overflow-hidden" },
                      [
                        _c("h4", [_vm._v("Cierres de ventas")]),
                        _c("sales-closures-table", {
                          attrs: {
                            "campaign-id": _vm.modalData.campaignId,
                            "total-income": _vm.amounts.totalIncome,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "rounded-lg overflow-hidden" },
                  [
                    _c("h4", [
                      _vm._v("ODCs de empresas de medios provisorias"),
                    ]),
                    _c("company-odc-table", {
                      attrs: {
                        data:
                          _vm.data && _vm.data.purchase_orders
                            ? _vm.data.purchase_orders
                            : [],
                        "is-final-table": false,
                        title: "ODCs de empresas de medios provisorias",
                      },
                      on: { getPurchaseOrderData: _vm.getPurchaseOrderData },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "rounded-lg overflow-hidden" },
                  [
                    _c(
                      "div",
                      { staticClass: "flex justify-between mb-2 items-end" },
                      [_c("h4", [_vm._v("ODCs de empresas de medios finales")])]
                    ),
                    _vm._l(
                      _vm.data && _vm.data.purchase_orders_grouped_by_month
                        ? _vm.data.purchase_orders_grouped_by_month
                        : [],
                      function (monthData, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-between bg-grey-light px-4 py-2",
                              },
                              [
                                _c("h5", { staticClass: "p-2 flex-1" }, [
                                  _vm._v(
                                    _vm._s(monthData.year) +
                                      " - " +
                                      _vm._s(
                                        _vm.monthFormatter(monthData.month)
                                      )
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "flex items-center gap-4" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-2",
                                      },
                                      [
                                        _c("span", { staticClass: "text-sm" }, [
                                          _vm._v("Ver anuladas"),
                                        ]),
                                        _c("vs-switch", {
                                          attrs: {
                                            value: _vm.getShowCanceledForMonth(
                                              monthData.year,
                                              monthData.month
                                            ),
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.toggleShowCanceledForMonth(
                                                monthData.year,
                                                monthData.month,
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vx-tooltip",
                                      {
                                        attrs: {
                                          text: "Esta opción solo está disponible para campañas programáticas",
                                          disabled: Boolean(
                                            _vm.modalData.isProgrammatic
                                          ),
                                        },
                                      },
                                      [
                                        _c(
                                          "vs-button",
                                          {
                                            staticClass:
                                              "bg-latinad-light text-white hover:bg-latinad transition-colors",
                                            attrs: {
                                              size: "small",
                                              disabled: !Boolean(
                                                _vm.modalData.isProgrammatic
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.closePurchaseOrdersByMonth(
                                                  {
                                                    month: monthData.month,
                                                    year: monthData.year,
                                                  }
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Generar ODC " +
                                                _vm._s(
                                                  _vm.monthFormatter(
                                                    monthData.month
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c("company-odc-table", {
                              attrs: {
                                data: _vm.filterPurchaseOrdersByMonth(
                                  monthData.purchase_orders,
                                  monthData.year,
                                  monthData.month
                                ),
                                "is-final-table": true,
                                showCheckboxes: true,
                                selectedCompanies:
                                  _vm.getSelectedCompaniesForMonth(
                                    monthData.year,
                                    monthData.month
                                  ),
                              },
                              on: {
                                getPurchaseOrderData: _vm.getPurchaseOrderData,
                                toggleCompanySelection: function ($event) {
                                  return _vm.toggleCompanySelectionForMonth(
                                    monthData.year,
                                    monthData.month,
                                    $event
                                  )
                                },
                                selectAllCompanies: function ($event) {
                                  return _vm.selectAllCompaniesForMonth(
                                    monthData.year,
                                    monthData.month,
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "p-2 px-4 flex justify-between bg-grey-dark text-white rounded-sm items-center",
                      },
                      [
                        _c("span", { staticClass: "font-bold text-xl" }, [
                          _vm._v("Total gasto:"),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass:
                              "font-bold rounded-lg p-2 bg-white text-latinad",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.stringCurrencyFormatter(
                                  _vm.amounts.totalSpent
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ]),
              _c("section", [
                _c(
                  "div",
                  {
                    staticClass:
                      "p-2 px-4 flex justify-between items-center bg-latinad text-white rounded-lg",
                  },
                  [
                    _c("span", { staticClass: "font-bold text-xl" }, [
                      _vm._v("Total"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "font-bold p-2 rounded-lg bg-white",
                        style: {
                          color: _vm.amounts.total >= 0 ? "#0096f5" : "#A50400",
                        },
                        attrs: { title: "Total ingreso - Total gasto" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.stringCurrencyFormatter(_vm.amounts.total))
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }